import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/calculer.png'
import _imports_1 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-db36d79e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-9"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-8",
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: "Le travail mécanique d'un corps en mouvement est un concept fondamental en physique, lié à l'énergie et au mouvement des objets. Il se réfère à l'énergie transférée à un corps lorsqu'une force est appliquée sur celui-ci et que le corps se déplace en raison de cette force. Voici les principaux concepts et formules associés au travail mécanique :\n                  Définition du Travail Mécanique Le travail (WW) effectué par une force (F) sur un corps est défini comme le produit scalaire de la force et du déplacement (d) du corps. Mathématiquement, cela peut être exprimé comme :\n\n      W=F*d\n",
      titre: "Travail mecanique d'un corps en mouvement",
      cacherCard: _ctx.cacherCard,
      questions: _ctx.questions,
      fichier: "travail_mecanique_corps"
    }, null, 8, ["cacherCard", "questions"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute bottom-5 right-20 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white w-16 h-16 rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.afficheParam && _ctx.afficheParam(...args)))
      }, _hoisted_2),
      _createElementVNode("div", {
        class: "absolute bottom-2 left-2 bg-white w-16 h-16 rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.afficherMenu && _ctx.afficherMenu(...args)))
      }, _hoisted_4),
      _createVNode(_component_RouterLink, {
        to: "/categorie",
        class: "fixed z-40 right-2 bottom-5 w-16 h-16"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_6,
      _createElementVNode("div", {
        class: "fixed z-40 right-2 bottom-5 w-16 h-16",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.actualiser && _ctx.actualiser(...args)))
      }, _hoisted_8)
    ], 2)
  ], 64))
}